import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningDuotoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .12,
		d: "M7.99992 15.1668C11.6818 15.1668 14.6666 12.1821 14.6666 8.50016C14.6666 4.81826 11.6818 1.8335 7.99992 1.8335C4.31802 1.8335 1.33325 4.81826 1.33325 8.50016C1.33325 12.1821 4.31802 15.1668 7.99992 15.1668Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.99992 5.8335V8.50016M7.99992 11.1668H8.00659M14.6666 8.50016C14.6666 12.1821 11.6818 15.1668 7.99992 15.1668C4.31802 15.1668 1.33325 12.1821 1.33325 8.50016C1.33325 4.81826 4.31802 1.8335 7.99992 1.8335C11.6818 1.8335 14.6666 4.81826 14.6666 8.50016Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgWarningDuotoneIcon;
